<template>
  <!-- BEGIN: Modal Content -->
  <div
    id="edit-amount-form-modal"
    class="modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- BEGIN: Modal Header -->
        <div class="modal-header">
          <h2 class="font-medium text-base mr-auto">
            Edit Amount
          </h2>
        </div>
        <!-- END: Modal Header -->
        <!-- BEGIN: Modal Body -->
        <div
          v-if="errorMessage !== ''"
          class="alert alert-danger-soft show flex items-center mb-2"
          role="alert"
        >
          <AlertOctagonIcon class="w-6 h-6 mr-2" />
          {{ errorMessage }}
        </div>
        <div class="modal-body grid grid-cols-12">
          <div class="col-span-12 mt-2">
            <label class="form-label"> Amount:</label>
            <input
              id="modal-form-1"
              v-model="amount"
              type="number"
              class="form-control col-span-6 gap-3"
            />
            <div v-if="validationErrors.amount" class="p-1 text-red-600">
              {{ validationErrors.amount[0] }}
            </div>
          </div>
        </div>
        <!-- END: Modal Body -->
        <!-- BEGIN: Modal Footer -->
        <div class="modal-footer text-right">
          <button
            type="button"
            data-dismiss="modal"
            class="btn btn-dark-soft w-20 mr-1"
          >
            Cancel
          </button>
          <button
            v-if="!isProcessing"
            type="button"
            class="btn btn-success w-40"
            @click="submitForm"
          >
            Submit
          </button>
          <button v-else class="btn btn-success w-40">
            Processing
            <LoadingIcon icon="oval" color="white" class="w-4 h-4 ml-2" />
          </button>
        </div>
        <!-- END: Modal Footer -->
      </div>
    </div>
  </div>
  <!-- END: Modal Content -->
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  setup() {
    const store = useStore();

    const isProcessing = computed(
      () => store.state.editAmountForm.isProcessing
    );

    const validationErrors = computed(
      () => store.state.editAmountForm.validationErrors
    );
    const errorMessage = computed(
      () => store.state.editAmountForm.errorMessage
    );

    const amount = computed({
      get: () => store.state.editAmountForm.amount,
      set: value => {
        store.commit("editAmountForm/setAmount", value);
      }
    });

    function submitForm(form) {
      store.dispatch("editAmountForm/submit", form);
    }

    return {
      amount,
      submitForm,
      validationErrors,
      errorMessage,
      isProcessing
    };
  }
});
</script>

<style scoped></style>
